import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import type { LucideIcon } from './icons';
import { IconPill } from './IconPill';
import type { AccentKey } from '../theme/accents';
import { colors, spacing, typography } from '../theme/tokens';

export interface FeatureHeaderProps {
  icon: LucideIcon;
  accent: AccentKey;
  title: string;
  subtitle?: string;
  testID?: string;
}

// En-tête de feature : pastille d'icône (pleine, accent de l'écran) + titre + sous-titre.
export function FeatureHeader({ icon, accent, title, subtitle, testID }: FeatureHeaderProps) {
  return (
    <View style={styles.container} testID={testID}>
      <IconPill icon={icon} accent={accent} variant="solid" testID={testID ? `${testID}-pill` : undefined} />
      <View style={styles.texts}>
        <Text style={styles.title}>{title}</Text>
        {subtitle ? <Text style={styles.subtitle}>{subtitle}</Text> : null}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flexDirection: 'row', alignItems: 'center', gap: spacing.md },
  texts: { flex: 1, gap: spacing.xs },
  title: { fontSize: typography.h1.size, fontWeight: typography.h1.weight, color: colors.grey900 },
  subtitle: { fontSize: typography.body.size, lineHeight: typography.body.lineHeight, color: colors.grey500 },
});
